import React, { useState } from 'react'

import Logs from './Logs'
import Users from './Users'
import Schemes from './Schemes'
import SaleItems from './SaleItems'
import Companies from './Companies'
import Documents from './Documents'
import Insurances from './Insurances'
import ItemGroups from './ItemGroups'
import RoutingGroups from './RoutingGroups'
import WorkstationSettings from './WorkstationSettings'

// Setup
import Roles from './setup/Roles'
import Reports from './setup/Reports'
import PaymentMethods from './setup/PayMethods'
import InputForms from './setup/InputForms'

import Routing, { SideMenu } from '../../components/reusable/routing'

const Admin = () => {
    let menu = [
        {
            path: '',
            title: 'Dashboard',
        },
        {
            path: 'store',
            title: 'Store',
        },
        {
            path: 'sale-items',
            title: 'Sale Items',
            component: SaleItems
        },
        {
            path: 'billing-inventory-groups',
            title: 'Billing & Inventory Groups',
            component: ItemGroups
        },
        {
            path: 'department-queues',
            title: 'Department Queues',
            component: RoutingGroups
        },
        {
            path: 'workstation-settings',
            title: 'Workstation Settings',
            component: WorkstationSettings
        },
        {
            path: 'system-logs',
            title: 'System Logs',
            component: Logs
        },
        {
            path: 'documents',
            title: 'Hosted Documents',
            component: Documents
        },
        {
            path: 'admissions',
            title: 'Admissions',
        },
        {
            path: 'users',
            title: 'Users',
            component: Users
        },
        {
            path: 'insurance-company',
            title: 'Insurance / Company',
            submenu: [
                {
                    path: 'company',
                    title: 'Company',
                    component: Companies
                },
                {
                    path: 'insurances',
                    title: 'Insurances',
                    component: Insurances
                },
                {
                    path: 'schemes',
                    title: 'Schemes',
                    component: Schemes
                }
            ]
        },
        {
            path: 'setup',
            title: 'Setup',
            submenu: [
                {
                    path: 'roles',
                    title: 'Roles',
                    component: Roles
                },
                {
                    path: 'input-forms',
                    title: 'Input Forms',
                    component: InputForms
                },
                {
                    path: 'reports',
                    title: 'Reports',
                    component: Reports
                },
                {
                    path: 'payment-method',
                    title: 'Payment Methods',
                    component: PaymentMethods
                },
                {
                    path: 'parameters',
                    title: 'Parameters'
                }
            ]
        }
    ]

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Administration</p>
                <SideMenu namespace="admin" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="admin" menu={ menu } />
            </div>
        </div>
    )
}

export default Admin
